import { FC, useEffect, useState } from 'react';
import { Box, Image, Text } from '@mantine/core';
import { openModal } from '@mantine/modals';
import { BookitupEntity, FileS } from '../../Service/FileS';

const BookitupEntityPreview: FC<BookitupEntity> = ({ entityId, entityType, fileName }) => {
  const [imageUrl, setImageUrl] = useState<string>();

  useEffect(() => {
    let objectUrl: string;

    FileS.get(entityType, entityId, fileName).then((blob) => {
      if (blob) {
        objectUrl = URL.createObjectURL(blob);
        setImageUrl(objectUrl);
      }
    });
    // Clean up to prevent memory leaks
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [entityId, entityType, fileName]);

  const onClick = () =>
    openModal({
      size: 'xl',
      title: (
        <Text weight="bolder" size="xl">
          {fileName}
        </Text>
      ),
      children: <Image src={imageUrl} />,
    });

  return imageUrl ? (
    <Box pos="relative">
      <Image src={imageUrl} width={200} fit="contain" alt="Vorschau" onClick={onClick} sx={{ cursor: 'pointer' }} />
    </Box>
  ) : null;
};

export default BookitupEntityPreview;
